import React from "react";

import { Link } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { commonErr } from "./errors";

import { IcInfomationTriangle, Success, Fail } from "../common/svg";

import car from "../../static/images/empty/empty-mycar.svg";

export const MessageLine = ({ message }) => {
	return (
		<div style={{ textAlign: "center", padding: "10vh" }}>
			<p className="no-result">{message}</p>
		</div>
	);
};

export const MessageBox = ({ show, hideModal, error, message, title }) => {
	return (
		<Modal show={show} onHide={hideModal} dialogClassName="modal-s modal-confirm">
			<Modal.Header closeButton={true} closeLabel={""}>
				<div className="wrap-svg">{error === commonErr.SUCCESS ? <Success /> : <Fail />}</div>
				{title && <h5>{title}</h5>}
			</Modal.Header>
			<Modal.Body>
				{message ? (
					<div className="modal-confirm-body renter-confirm-body">
						<p className="font-18">{message}</p>
					</div>
				) : null}
			</Modal.Body>
		</Modal>
	);
};

export const MessagePage = ({ message }) => {
	return (
		<div className="min-height-no-footer" style={{ textAlign: "center", padding: "30vh 10vh" }}>
			<p className="no-result">{message}</p>
		</div>
	);
};

export const MessageOwnerIncome = ({ message, show, hideModal }) => {
	return (
		<Modal show={show} onHide={hideModal} dialogClassName="modal-s modal-dialog">
			<Modal.Header closeButton={true} closeLabel={""}>
				<h5>THU NHẬP ƯỚC TÍNH CỦA CHỦ XE</h5>
			</Modal.Header>
			<Modal.Body className="owner-register-body">{message}</Modal.Body>
		</Modal>
	);
};

export const MessageErr = ({errMsg}) => {
	return (
		<div className="calendar d-flex">
			<div className="wrap-svg" style={{ marginBottom: "12px", marginRight: "5px" }}>
				<IcInfomationTriangle />
			</div>
			<p className="note text-danger">{errMsg}</p>
		</div>
	)
}

/* Empty Block */

export const Empty = ({ msg, img, subMsg }) => {
	return (
		<div className="empty-container">
			<img loading="lazy" src={img} alt="" />
			<p>{msg}</p>
			{subMsg ? <p className="sub">{subMsg}</p> : null}
		</div>
	);
};

